module.exports = __webpack_public_path__ + "img/galeria-desportiva-2.26916b92.jpg";